import axios from 'axios'
import baseURL from './baseURL'
// 创建axios实例
const service = axios.create({
    baseURL: baseURL, // 
    timeout: 15000 // 
})

export default service


// WEBPACK FOOTER //
// ./src/utils/config.js